import Carousel, { CarouselSlide, CarouselType } from '@components/ui/Carousel'
import { useMemo, useRef } from 'react'
import styles from './styles.module.scss'
import { useMediaQuery } from '@helpers/hooks'
import { BREAKPOINT_SIZES } from '@consts/index'
import { MixAndMatchProduct } from '..'
import { getIsFirstTimeUser } from '@helpers/session/user'
import { analytics } from '@helpers/analytics'

type GallerySliderProperties = {
  products: MixAndMatchProduct[]
  category: string
  sliderName: 'Slider Top' | 'Slider Bottom'
  setActiveCategory: React.Dispatch<React.SetStateAction<GalleryState>>
}
function GallerySlider({
  products,
  category,
  sliderName,
  setActiveCategory
}: GallerySliderProperties) {
  const isDesktop = useMediaQuery({
    minWidth: BREAKPOINT_SIZES.DESKTOP,
    initialState: true
  })
  const carouselRef = useRef<CarouselType>()
  const carouselSettings = useMemo(
    () => ({
      speed: 10,
      slidesToScroll: 1,
      startIndex: 0,
      loop: true,
      buttons: true,
      buttonsVariant: 'primary' as const,
      afterChange: (value: number) => {
        setActiveCategory(currentState => ({
          ...currentState,
          [category]: value
        }))
        const firstTimeUser = getIsFirstTimeUser()
        analytics('Click', {
          category: 'Landing Page',
          label: 'Mix-Match',
          action: sliderName,
          type: firstTimeUser ? 'new' : 'existing'
        })
      }
    }),
    []
  )

  return (
    <Carousel
      carouselClasses={styles.mixAndMatchGallery__Carousel}
      settings={carouselSettings}
      instance={carouselInstance => (carouselRef.current = carouselInstance)}
    >
      {products.map(product => (
        <CarouselSlide key={product.id}>
          <img
            alt={`${product.title} ${product.productType}`}
            src={isDesktop ? product.gallery.desktop : product.gallery.mobile}
          />
        </CarouselSlide>
      ))}
    </Carousel>
  )
}

type GalleryState = { tops: number; bottoms: number }

type MixAndMatchGalleryProps = {
  products: {
    bottoms: MixAndMatchProduct[]
    tops: MixAndMatchProduct[]
  }
  setActiveCategory: React.Dispatch<React.SetStateAction<GalleryState>>
}
export default function MixAndMatchGallery({
  products,
  setActiveCategory
}: MixAndMatchGalleryProps) {
  const topsProducts = products.tops.filter(
    product => product.category === 'tops'
  )
  const bottomsProducts = products.bottoms.filter(
    product => product.category === 'bottoms'
  )

  return (
    <div className={styles.mixAndMatchGallery}>
      <GallerySlider
        products={topsProducts}
        category="tops"
        sliderName="Slider Top"
        setActiveCategory={setActiveCategory}
      />
      <GallerySlider
        products={bottomsProducts}
        category="bottoms"
        sliderName="Slider Bottom"
        setActiveCategory={setActiveCategory}
      />
    </div>
  )
}
